import { IAuthInterface } from "@gwn/guac-lib";

let authorization: IAuthInterface = null!;

export const getAuthorizationInterface = (): IAuthInterface => {
  if (authorization) return authorization;

  return {
    logout: () => {},
    userEmail: "",
    userRoles: [],
    getJwt: () => "",
    getToken: () => ({}),
    isTokenExpired: () => true,
    isUserRoleMember: () => false,
  };
};

export const setAuthorizationInterface = (newAuthorizationInterface: IAuthInterface) => {
  if (authorization) return;

  authorization = newAuthorizationInterface;
};
